module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Files/Share-3ca0342363ab16e90e56776b8b9fd6df568631283d55bd1a31f70cab1c8abffa.svg";